import { SDS_FONT_SIZE_BODY_XSMALL, SDS_FONT_LINEHEIGHT_BODY_XSMALL, SDS_FONT_SIZE_HEADING_XXXSMALL, SDS_FONT_LINEHEIGHT_HEADING_XXXSMALL, SDS_FONT_SIZE_HEADING_XXSMALL, SDS_FONT_LINEHEIGHT_HEADING_XXSMALL, SDS_FONT_SIZE_HEADING_XSMALL, SDS_FONT_LINEHEIGHT_HEADING_XSMALL, SDS_FONT_SIZE_HEADING_SMALL, SDS_FONT_LINEHEIGHT_HEADING_SMALL, SDS_FONT_WEIGHT_MEDIUM, SDS_FONT_FAMILY_PRIMARY } from '@s-group/design-system-tokens/web/tokens/font.es6.js';
import { css } from 'styled-components';

const font = ({ sizing }) => sizing &&
    [
        {
            // size: [font-size, line-height]
            xsmall: [
                SDS_FONT_SIZE_BODY_XSMALL,
                SDS_FONT_LINEHEIGHT_BODY_XSMALL,
            ],
            small: [
                SDS_FONT_SIZE_HEADING_XXXSMALL,
                SDS_FONT_LINEHEIGHT_HEADING_XXXSMALL,
            ],
            medium: [
                SDS_FONT_SIZE_HEADING_XXSMALL,
                SDS_FONT_LINEHEIGHT_HEADING_XXSMALL,
            ],
            large: [
                SDS_FONT_SIZE_HEADING_XSMALL,
                SDS_FONT_LINEHEIGHT_HEADING_XSMALL,
            ],
            xlarge: [
                SDS_FONT_SIZE_HEADING_SMALL,
                SDS_FONT_LINEHEIGHT_HEADING_SMALL,
            ],
        }[sizing],
    ]
        .map(([fontSize, lineHeight]) => `${SDS_FONT_WEIGHT_MEDIUM} ${fontSize} / ${lineHeight} '${SDS_FONT_FAMILY_PRIMARY}'`)
        .join('');
const LabelStyles = css `
    border: 0;
    color: ${({ theme }) => theme.colors.SDS_BRAND_COLOR_TEXT_DEFAULT_GREY};
    display: block;
    font: ${font};
    margin: 0;
    padding: 0;
`;

export { LabelStyles };
//# sourceMappingURL=Label.styles.js.map
